module.exports = __webpack_public_path__ + "img/gmdl_pic2.8241a569.png";